import { NgModule } from '@angular/core';

//******************************************************************************
//  Import Core Components
//******************************************************************************
import { CoreImports } from '~/core/classes/imports/core.imports';

//******************************************************************************
//  Import External Components
//******************************************************************************
import { ExternalImports } from '~/classes/imports/external.imports';

//******************************************************************************
//  Pipes
//******************************************************************************
import { SafePipe } from '~/core/pipes/safe.pipe';

//******************************************************************************
//  App Standalone Components (used in standalone component imports[])
//******************************************************************************
import { PromptSelectionComponent } from '~/pages/prompt-selection/prompt-selection';
import { LandingScreenComponent } from '~/pages/wells-pa-insights/components/landing-screen/landing-screen.component';
import { NavSidebarComponent } from '~/pages/wells-pa-insights/components/nav-sidebar/nav-sidebar.component';
import { ChatPanelComponent } from '~/pages/wells-pa-insights/components/chat-panel/chat-panel.component';
import { WellsSummaryTabComponent } from '~/pages/wells-pa-insights/components/dashboard/wells-summary-tab/wells-summary-tab.component';
import { NptSummaryTabComponent } from '~/pages/wells-pa-insights/components/dashboard/npt-summary-tab/npt-summary-tab.component';
import { CostPerformanceTabComponent } from '~/pages/wells-pa-insights/components/dashboard/cost-performance-tab/cost-performance-tab.component';
import { LessonsTabComponent } from '~/pages/wells-pa-insights/components/dashboard/lessons-tab/lessons-tab.component';

/** Flat array consumed by standalone component imports[] */
export const APP_IMPORTS: any[] = [
    PromptSelectionComponent,
    LandingScreenComponent,
    NavSidebarComponent,
    ChatPanelComponent,
    WellsSummaryTabComponent,
    NptSummaryTabComponent,
    CostPerformanceTabComponent,
    LessonsTabComponent,
];

const services: any[] = [];

@NgModule({
    imports: [
        CoreImports,
        ExternalImports,
        // Standalone components can be imported directly into an NgModule
        ...APP_IMPORTS,
    ],
    declarations: [
        SafePipe,
    ],
    exports: [
        ...APP_IMPORTS,
        SafePipe,
    ],
    providers: [
        ...services,
    ],
})

export class AppImports { }
